import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'mt-modal',
    templateUrl: './modal.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ModalComponent implements OnInit {
  @Input() title: string;
  @Input() contentbody: boolean;
  @Input() variant: string = 'primary';
  @Input() disabled: boolean = false;
  @Input() skipVariantDefaults = false;
  @Output() onAction = new EventEmitter<any>();
  @Input() buttons: any = [
    { label: 'Cancel', class: 'nobg error', submit: false },
    { label: 'Submit', class: '', submit: true }
  ];
  constructor() { }

  ngOnInit() {
    if (this.skipVariantDefaults) {
      return;
    }
    const btns = [{ label: 'Cancel', class: 'nobg error', submit: false }];
    if (this.variant === 'delete') {
      const arr = [{ label: 'Delete', class: 'error', submit: true }];
      this.buttons = [...btns, ...arr];
    }
    if (this.variant === 'warning') {
      const arr = [{ label: 'Submit', class: 'warning', submit: true }];
      this.buttons = [...btns, ...arr];
    }
  }

  onClickAction($event: any) {
    this.disabled = true;
    this.onAction.emit($event);
  }
}

// update your button names
// actionBtns: any = [
//   { label: 'Cancel', class: 'nobg error', submit: false },
//   { label: 'Allocate to user', class: '', submit: true }
// ]
